import React from "react";
import { BrowserRouter as Router, Switch, Route, Redirect } from 'react-router-dom';
import TestList from "containers/TestList";
import PartList from "containers/PartList";
import Part from "containers/Part";
import PartDetail from "containers/PartDetail";
import PartDetailFill from "containers/PartDetailFill";
import PartDetailTyping from "containers/PartDetailTyping";
import ToolsHome from "tools/ToolsHome";
import Recorder from "tools/Recorder";
import VideoLogoOverlay from "tools/VideoLogoOverlay";
import ConvertImage from "tools/ConvertImage";
import CompressImage from "tools/CompressImage";
import ConvertAudio from "tools/ConvertAudio";
import ConvertVideo from "tools/ConvertVideo";
import ConvertText from "tools/ConvertText";
import JsonFormatter from "tools/JsonFormatter";
import Pronunciation from "tools/Pronunciation";
import TextToSpeech from "tools/TextToSpeech";
import Dictation from "tools/Dictation";
import { DEFAULT_TOEIC_YEAR } from "config/defaultYear";

const Root = () => {
  return (
    <Router>
      <Switch>
        <Route path="/tools/video-logo">
          <VideoLogoOverlay />
        </Route>
        <Route path="/tools/convert-image">
          <ConvertImage />
        </Route>
        <Route path="/tools/compress-image">
          <CompressImage />
        </Route>
        <Route path="/tools/convert-audio">
          <ConvertAudio />
        </Route>
        <Route path="/tools/convert-video">
          <ConvertVideo />
        </Route>
        <Route path="/tools/convert-text">
          <ConvertText />
        </Route>
        <Route path="/tools/json-formatter">
          <JsonFormatter />
        </Route>
        <Route path="/tools/pronunciation">
          <Pronunciation />
        </Route>
        <Route path="/tools/text-to-speech">
          <TextToSpeech />
        </Route>
        <Route path="/tools/dictation">
          <Dictation />
        </Route>
        <Route exact path="/tools">
          <ToolsHome />
        </Route>
        <Route path="/record">
          <Recorder />
        </Route>
        <Route path="/toeic:year/test:testNumber/part:partNumber/question:questionNumber/typing">
          <PartDetailTyping />
        </Route>
        <Route path="/toeic:year/test:testNumber/part:partNumber/question:questionNumber/fill">
          <PartDetailFill />
        </Route>
        <Route path="/toeic:year/test:testNumber/part:partNumber/question:questionNumber">
          <PartDetail />
        </Route>
        <Route path="/toeic:year/test:testNumber/part:partNumber">
          <Part />
        </Route>
        <Route path="/toeic:year/test:testNumber">
          <PartList />
        </Route>
        <Route path="/toeic:year">
          <TestList />
        </Route>

        <Route path="/">
          <Redirect to={`/toeic${DEFAULT_TOEIC_YEAR}`} />
        </Route>
      </Switch>
    </Router >
  );
};

export default Root;
